<template>
  <v-container fluid grid-list-lg>
    <Create :createDialog="createDialog" :CustomerId="CustomerId" @close="createDialog = false"
      @submit="createCustomerSubmit">
    </Create>
    <Edit :editDialog="editDialog" @close="editDialog = false" @submit="editStudentSubmit"
      :editStudent="selectedStudent">
    </Edit>
    <MoveStudent :moveStudentDialog="moveStudentDialog" @close="moveStudentDialog = false" @submit="moveStudentSubmit"
      :student="selectedStudent">
    </MoveStudent>

    <!-- <AssignTeacher @submit="assignSubmit" :Student="selectedStudent" :editDialog="assignClassRoomDialog"
      @close="assignClassRoomDialog = false"></AssignTeacher> -->
    <AssignClassRoom @submit="assignClassRoomSubmit" :Student="selectedStudent" :editDialog="assignClassRoomDialog"
      @close="assignClassRoomDialog = false"></AssignClassRoom>

    <ReportCard :Student="selectedStudent" :Dialog="reportCardDialog" @close="reportCardDialog = false"></ReportCard>

    <AssignClass @submit="assignClassSubmit" :Student="selectedStudent" :editDialog="assignClassDialog"
      @close="assignClassDialog = false"></AssignClass>

    <v-card :loading="loading" outlined>
      <v-toolbar dense flat color="grey lighten-3">
        <v-app-bar-nav-icon v-if="!CustomerId & !ClassId" @click="$router.go(-1)">
          <v-icon>mdi-chevron-left</v-icon>
        </v-app-bar-nav-icon>
        <v-toolbar-title>
          {{ studentTitle }}
        </v-toolbar-title>
        <v-spacer> </v-spacer>
        <v-layout row wrap justify-end>
          <v-flex shrink>
            <v-btn @click="add" outlined rounded raised small>
              <v-icon small>add</v-icon> New
            </v-btn>
          </v-flex>
          <v-flex shrink>
            <v-btn class="mr-2"  :disabled="count < 1" raised outlined rounded
              :loading="downloadLoading" small>
              <download-excel :fetch="fetchStudentsForDownload" worksheet="Student List" :stringifyLongNum="true" type="xls"
                :fields="fields" name="student">
                <span >Download</span>
              </download-excel>
            </v-btn>
          </v-flex>
          <v-flex shrink>
            <v-checkbox label="Show Left Students" v-model="showLeft"></v-checkbox>
          </v-flex>
        </v-layout>



      </v-toolbar>

      <v-card-title>
        <v-row>
          <v-col cols="12" md="4">
            <div>
              <v-text-field v-model="search" outlined prepend-inner-icon="search" rounded dense label="Search"
                single-line hide-details clearable></v-text-field>
            </div>
            <div>
              <v-checkbox label="Open Profile New Tab" v-model="openNewTab"></v-checkbox>
            </div>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" md="4">
            <ClassesDropbox @classSelected="classSelected" />
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table :server-items-length="count" :footer-props="{ 'items-per-page-options': [10, 25, 35, 50] }"
        class="pageHeight" :headers="headers" ref="myTable" :items="students" :search="search" :loading="loading"
        :options.sync="options">
        <template v-slot:item="{ item }">
          <tr class="pointer">
            <!-- <td class="text-left" :class="{ 'text-decoration-line-through': item.leftDate }">
              <span class="mr-2">{{ item.localId }}</span>

            </td> -->

            <td class="text-left" :class="{ 'text-decoration-line-through': item.leftDate }"
              @click="viewProfile(tabOpen, item.CustomerId)">
              <div>
                <span class="text-capitalize" :class="{ 'text-decoration-line-through': item.leftDate }">
                  {{ item.fullName
                  }}</span>
                <span class="ml-2">
                  <v-chip small label color="grey lighten-4">
                    Starts {{ item.createdAt | moment("MMM DD, YY") }}
                    <v-icon small right>
                      mdi-clock-time-eight-outline
                    </v-icon>
                  </v-chip>
                </span>
                <span class="ml-1">
                  <v-tooltip bottom v-if="item.Customer.payCompassId">
                    <template v-slot:activator="{ on, attrs }">
                      <v-avatar size="10" color="yellow" v-bind="attrs" v-on="on" />
                    </template>
                    <span>Set for online payment</span>
                  </v-tooltip></span>
              </div>
              <div><v-chip small dark v-if="item.leftDate">Left On: {{ item.leftDate | moment('MM/DD/YYYY')
                  }}</v-chip>
              </div>


            </td>

            <td>
              <v-tooltip bottom v-if="!item.subscriptionCount">
                <template v-slot:activator="{ on, attrs }">
                  <v-avatar size="10" color="yellow" v-bind="attrs" v-on="on" />
                </template>
                <span>No active subscription</span>
              </v-tooltip>
            </td>

            <td @click="viewProfile(tabOpen, item.CustomerId)"
              :class="{ 'text-decoration-line-through': item.leftDate }" class="text-left" v-if="!CustomerId">
              <span v-if="item.Customer && item.Customer.fatherName">{{
                item.Customer.fatherName
                }}</span>
              <div v-if="item.Customer && item.Customer.fatherPhoneNumber">{{
                item.Customer.fatherPhoneNumber
                }}</div>
            </td>



            <td @click="viewProfile(tabOpen, item.CustomerId)" class="text-left">
              <v-progress-circular :size="35" :width="3" :value="item.per" color="teal">
                <span class="caption">{{ item.per }}</span>
              </v-progress-circular>
            </td>

            <!-- <td @click="viewProfile('in', item.CustomerId)" class="text-left"
              :class="{ 'text-decoration-line-through': item.leftDate }">
              {{ item.reference }}
              <div><v-chip x-small dark v-if="item.leftDate">Left On: {{ item.leftDate | moment('MM/DD/YYYY')
                  }}</v-chip>
              </div>
            </td> -->



            <td class="text-left" :class="{ 'text-decoration-line-through': item.leftDate }">
              <div @click="viewProfile(tabOpen, item.CustomerId)" v-if="item.ClassStudents.length">
                <div v-for="(classStudents, index) in item.ClassStudents" :key="index">
                  <v-tooltip bottom v-if="classStudents.countInSubscription">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon small color="green" v-bind="attrs" v-on="on">mdi-check-decagram</v-icon>
                    </template>
                    <span>Once the subscription runs and the invoice is created, this class will be included in the
                      invoice.</span>
                  </v-tooltip>
                  <v-tooltip bottom v-else>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon small v-bind="attrs" v-on="on">mdi-close-thick</v-icon>
                    </template>
                    <span>Despite this class being assigned to the student, they will not be charged when the invoice is
                      created.</span>
                  </v-tooltip>
                  <!-- <v-icon small v-else>mdi-close-thick</v-icon> -->
                  {{ classStudents.Class.name }} - {{ classStudents.parentPay | currency }}
                </div>


              </div>
              <div @click="assignClass(item)" v-else>
                <v-chip small color="pink" text-color="white" class="font-weight-bold pointer" label>
                  Class Not Select
                </v-chip>
              </div>

              <div>
                <div @click="viewProfile(tabOpen, item.CustomerId)" v-if="item.ClassRoomStudents.length">
                  <div v-for="(classRoom, index) in item.ClassRoomStudents" :key="index">
                    <div v-if="classRoom.ClassRoom">{{ classRoom.ClassRoom.name }}</div>
                    <div v-else>
                      <v-chip small color="pink" text-color="white" class="font-weight-bold" label>
                        Not Assigned To Any Room
                      </v-chip>
                    </div>
                  </div>


                </div>
                <div @click="item.ClassStudents.length ? assignClassroom(item) : undefined" v-else>
                  <v-chip small color="pink" text-color="white" class="font-weight-bold pointer" label>
                    Not Assigned To Any Room
                  </v-chip>
                </div>
              </div>
            </td>


            <!-- <td :class="{ 'text-decoration-line-through': item.leftDate }" class="text-left">

            </td> -->


            <td :class="{ 'text-decoration-line-through': item.leftDate }" class="text-right"
              @click="viewProfile(tabOpen, item.CustomerId)">
              <div>{{ item.totalFee | currency }}</div>
              <div v-if="showBalance === 'show'">
                <div v-if="item.Customer && item.Customer.balance" class="red--text font-weight-bold">{{
                  item.Customer.balance |
                  currency }}</div>
              </div>

            </td>

            <!-- <td :class="{ 'text-decoration-line-through': item.leftDate }" class="text-right"
              @click="viewProfile('in', item.CustomerId)">
              <div v-if="item.Customer && item.Customer.balance" class="red--text font-weight-bold">{{
                item.Customer.balance |
                currency }}</div>
              <div v-else>{{ 0 | currency }}</div>
            </td> -->

            <td class="justify-end align-center text-right">
              <v-menu bottom left offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" icon>
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list class="menu-button">
                  <v-list-item v-if="!item.ClassRoomStudents.length && !item.leftDate && item.ClassStudents.length"
                    @click="assignClassroom(item)">
                    <v-list-item-title>Assign Classroom</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="!item.leftDate" @click="assignClass(item)">
                    <v-list-item-title>Assign Department</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="!item.leftDate && item.ClassRoomStudents.length" @click="viewReportCard(item)">
                    <v-list-item-title>Report Card</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="!item.leftDate" @click="editStudent(item)">
                    <v-list-item-title>Edit</v-list-item-title>
                  </v-list-item>
                  <v-divider v-if="!item.leftDate"></v-divider>
                  <v-list-item v-if="item.leftDate" @click="backStudent(item)">
                    <v-list-item-title>Student Back</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-else @click="leftStudentOpen(item)">
                    <v-list-item-title>Student Left</v-list-item-title>
                  </v-list-item>

                  <v-list-item v-if="!item.leftDate" @click="moveStudentOpen(item)">
                    <v-list-item-title>Move Student</v-list-item-title>
                  </v-list-item>

                  <v-list-item @click="deleteStudent(item)">
                    <v-list-item-title>Delete</v-list-item-title>
                  </v-list-item>
                  <v-divider v-if="item.Customer && item.Customer.balance"></v-divider>
                  <v-list-item v-if="item.Customer && item.Customer.balance"
                    @click="viewBalanceLetter(item.CustomerId)">
                    <v-list-item-title>View Pending Bal Letter</v-list-item-title>
                  </v-list-item>
                  <v-list-item 
                    @click="viewChangeLetter(item.id)">
                    <v-list-item-title>View Fee Change Letter</v-list-item-title>
                  </v-list-item>
                  
                </v-list>
              </v-menu>


            </td>
          </tr>
        </template>
        <template v-slot:body.append="{ headers }">
          <tr :style="{ 'background-color': $style.listTotal.result }">
            <td :colspan="headers.length - 2" class="text-right font-weight-bold">
              Total Fee
            </td>

            <td class="text-right font-weight-bold">
              {{ totalFee | currency }}
            </td>
            <td></td>
          </tr>
        </template>
        <!-- <v-alert slot="no-results" :value="true" color="error" icon="warning">Your search for "{{ search }}" found no
          results.</v-alert> -->
      </v-data-table>


    </v-card>
    <v-dialog v-model="leftStudentDialog" width="400">
      <v-card>
        <ModelTitle title="Left Student Date" @close="leftStudentClose()" />
        <v-container grid-list-lg>
          <DateSelector :notClearable="true" label="Left Date" v-model="leftDate" />
        </v-container>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="leftStudent()">
            Left Student
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import studentService from "../service";
import ClassesDropbox from "@/modules/Classes/components/Dropbox.vue";
import DateSelector from "@/components/DateSelector";
import attService from '@/modules/TeacherModules/Attendance/service.js'
import { mapGetters } from "vuex";

const Create = () => import("./Create");
const Edit = () => import("./Edit");
const MoveStudent = () => import("./MoveStudent");
// const AssignTeacher = () =>
//   import("@/modules/Student/components/AssignTeacher.vue");
const AssignClass = () =>
  import("@/modules/Student/components/AssignClass.vue");
const AssignClassRoom = () =>
  import("@/modules/Student/components/AssignClassRoom.vue");
const ReportCard = () =>
  import("@/modules/Student/components/ReportCard.vue");

import Hashids from "hashids";
const hashids = new Hashids();

export default {
  props: {
    showBalance: {
      default: 'show',
    },
    CustomerId: {
      default: null,
    },
    ClassId: {
      default: null,
    },
    showAll: {
      default: false,
    },
    // due: {
    //   default: false,
    // },
  },
  name: "student-list",
  data() {
    return {
      openNewTab: true,
      tabOpen: 'out',
      count: 0,
      showLeft: false,
      leftStudentDialog: false,
      moveStudentDialog: false,
      leftDate: this.$moment().toISOString(),
      assignClassRoomDialog: false,
      assignClassDialog: false,
      createDialog: false,
      reportCardDialog: false,
      editDialog: false,
      selectedStudent: null,
      headers: [],
      students: [],
      search: null,
      downloadLoading: false,
      loading: true,
      pageCount: 0,
      selectedClasses: [],
      fields: {
        Date: 'date',
        Name: 'fullName',
        Father_Name: 'Customer.fatherName',
        Father_Contact: 'Customer.fatherPhoneNumber',
        Attendance: 'attendance',
        Departments: 'combinedClassNames',
        ClassRooms: 'combinedClassRooms',
        Fee: 'totalFee'
      },
      Attendance: [],
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['firstName'],
        sortDesc: [false]
      },
    };
  },
  async created() {
    await this.getAttendance();
    await this.getList();
    document.title = "taleem - Student List";

    // this.headers.push({
    //   text: '',
    //   align: "center",
    //   width: '55px',
    //   sortable: false,
    // })
    // this.headers.push({
    //   text: 'Create At',
    //   align: "left",
    //   value: "createdAt",
    //   sortable: true,
    // }
    // );

    this.headers.push({
      text: 'Name',
      align: "left",
      value: "firstName",
      sortable: true,
    },
    {
      text: "",
      width: '55px',
      sortable: false,
    });

    if (!this.CustomerId) {
      this.headers.push({
        text: "Parent",
        align: "left",
        value: "Customer.name",
        sortable: false,
      });
    }
    this.headers.push(
      {
        text: "",
        value: "",
        sortable: false,
      },

      {
        text: "Department",
        value: "ClassStudents[0].Class.name",
        sortable: false,
      },
      {
        text: "Fee",
        value: "totalFee",
        align: "right",
        sortable: false,
      },
      // {
      //   text: "Outstanding Balance",
      //   value: "Customer.balance",
      //   align: "right",
      //   sortable: true,
      // },
      {
        text: "",
        value: "action",
        sortable: false,
      }
    );
    this.$events.listen("studentListEvent", () => this.getList());
  },
  beforeDestroy() {
    this.$events.remove("studentListEvent");
  },
  components: {
    Create,
    Edit,
    MoveStudent,
    AssignClass,
    AssignClassRoom,
    ClassesDropbox,
    DateSelector,
    ReportCard
    // AssignTeacher,
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
    studentTitle() {
      return this.count + ' Students'

    },
    totalFee() {
      let total = 0
      this.students.map(row => {
        total += row.totalFee
      })
      return total
    }
  },
  watch: {
    openNewTab(val) {
      if (val) {
        this.tabOpen = 'out'
      } else {
        this.tabOpen = 'in'
      }
    },
    showLeft() {
      this.getList()
    },
    search: {
      handler(val) {
        if (val.length < 2) {
          return true
        }
        this.getList();
      }
    },
    options: {
      handler() {
        this.getList();
      },
      deep: true,
    },
    //   search() {
    //     console.log('this.$refs.myTable.selectableItems', this.$refs.myTable.selectableItems)
    //   }
  },
  methods: {
    fetchStudentsForDownload(){
      this.downloadLoading = true
      let downloadStudents = this.students
      downloadStudents.map(row => {
        row.date = this.$moment(row.createdAt).format("MM/DD/YYYY")
        row.attendance = `${row.per}/100`
        row.combinedClassNames = row.ClassStudents.map(classStudents => classStudents.Class?.name) //check if class exists
        .filter(name => name) // Remove undefined or falsy values
        .join("\n"); // join with line break
        row.combinedClassRooms = row.ClassRoomStudents.map(classRoom => classRoom.ClassRoom?.name).filter(name => name)
        .join("\n");
      })
      this.downloadLoading = false
      return downloadStudents
    },
    customFilter(value, search, item) {
      if (!search) return true;
      const searchValue = search.toLowerCase();

      const checkNested = (obj, searchValue) => {
        for (let key in obj) {
          if (typeof obj[key] === 'object' && obj[key] !== null) {
            if (checkNested(obj[key], searchValue)) {
              return true;
            }
          } else if (String(obj[key]).toLowerCase().includes(searchValue)) {
            return true;
          }
        }
        return false;
      };

      return checkNested(item, searchValue);
    },
    // customFilter(value, search, item) {
    //   if (!search) return true;
    //   const searchValue = search.toLowerCase();

    //   const fullName = item.fullName ? item.fullName.toLowerCase() : '';
    //   const fatherName = item.Customer && item.Customer.fatherName ? item.Customer.fatherName.toLowerCase() : '';
    //   const fatherPhoneNumber = item.Customer && item.Customer.fatherPhoneNumber ? item.Customer.fatherPhoneNumber.toLowerCase() : '';

    //   return (
    //     fullName.includes(searchValue) ||
    //     fatherName.includes(searchValue) ||
    //     fatherPhoneNumber.includes(searchValue)
    //   );
    // },
    classSelected(val) {
      this.selectedClasses = val
      this.getList()
    },
    assignClassSubmit() {
      // this.$events.emit("customerProfileEvent");
      this.assignClassDialog = false;
      this.getList();
    },
    assignClassRoomSubmit() {
      this.assignClassRoomDialog = false;
      this.getList();
    },
    editStudentSubmit() {
      // this.$events.emit("customerProfileEvent");
      this.getList();
    },
    moveStudentSubmit() {
      // this.$events.emit("customerProfileEvent");
      this.getList();
    },
    createCustomerSubmit() {
      // this.$events.emit("customerProfileEvent");
      this.getList();
    },
    viewProfile(open, id) {

      if (!this.CustomerId) {
        if (open === 'out') {
          let routeData = this.$router.resolve({ path: `/parents/${id}/profile` });
          window.open(routeData.href, '_blank');
        } else {
          this.$router.push({ path: `/parents/${id}/profile` });
        }
      }


      // this.$router.push({ path: `/parents/${id}/profile` });
    },
    viewReportCard(val) {
      this.selectedStudent = val,
        this.reportCardDialog = true
    },
    add() {
      this.createDialog = !this.createDialog;
    },
    getList() {
      this.loading = true;
      this.editDialog = false
      this.createDialog = false
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      let offset = 0
      if (itemsPerPage > 0 && page) {
        offset = itemsPerPage * page - itemsPerPage;
      }
      let where = {
        showLeft: this.showLeft,
        filteredClasses: this.selectedClasses,
        limit: itemsPerPage,
        sortBy: sortBy[0],
        sortDesc: sortDesc[0],
      };
      if (this.search && this.search.length >= 3) {
        where.search = this.search
      } else {
        where.offset = offset
      }
      if (this.CustomerId) {
        where.CustomerId = this.CustomerId;
      }
      if (this.ClassId) {
        where.ClassId = this.ClassId;
      }


      return studentService.getAll(where).then(async(response) => {
        // console.log('response get all student', response)
        await this.getStudentCount()
        this.loading = false;
        this.students = response.data;
        this.itemsPerPage = this.students.length
        this.students.map(student => {
          student.totalFee = 0
          if (student.ClassStudents.length !== 0) {
            student.ClassStudents.map(row => {
              student.totalFee += row.parentPay
              student.per = 0
            })
          }
        })
        this.setAttendance()
      });
    },
    getStudentCount() {
      let where = {
        showLeft: this.showLeft,
        filteredClasses: this.selectedClasses,
      };
      if (this.search && this.search.length >= 3) {
        where.search = this.search
      }
      if (this.CustomerId) {
        where.CustomerId = this.CustomerId;
      }
      if (this.ClassId) {
        where.ClassId = this.ClassId;
      }

      return studentService.getStudentCount(where).then((response) => {
        this.count = response.count;
      });
    },
    getAttendance() {
      const where = {
        start: this.$moment()
          .startOf("month")
          .toISOString(),
        end: this.$moment()
          .endOf("month")
          .toISOString(),
      }
      console.log('where', where)
      return attService.attendanceInfo(where)
        .then(response => {
          // console.log('response attendanceInfo', response)

          this.Attendance = response.data

        })
    },
    setAttendance() {
      // console.log('return')
      this.Attendance.map(async (row) => {
        row.per = ((row.totalPresentAttendance + row.totalLateAttendance + row.totalLeaveAttendance) / row.totalAttendance) * 100
        await Promise.all(
          this.students.map(student => {
            if (student.id === row.id) {
              if (isNaN(parseInt(row.per))) {
                student.per = 0
              } else {
                student.per = parseInt(row.per)
              }
            }
          }))
      })
    },
    editStudent(obj) {
      this.selectedStudent = obj;
      this.editDialog = !this.editDialog;
    },
    assignClassroom(obj) {
      this.selectedStudent = obj;
      this.assignClassRoomDialog = !this.assignClassRoomDialog;
    },
    assignClass(obj) {
      this.selectedStudent = obj;
      this.assignClassDialog = !this.assignClassDialog;
    },
    backStudent(student) {
      this.$swal({
        title: "Are you sure?",
        text: `${student.fullName} is back the school.`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          studentService.update(student.id, {
            leftDate: null,
            markBack: true
          }).then((response) => {
            if (response.data) {
              this.$swal("Back!", "Student was marked Back.", "success");
              this.$events.emit("customerProfileEvent")
              this.getList();
            }
          });
        }
      });
    },
    leftStudentOpen(student) {
      this.leftStudentDialog = true
      this.selectedStudent = student
    },
    moveStudentOpen(student) {
      this.moveStudentDialog = true
      this.selectedStudent = student
    },
    leftStudent() {
      this.leftStudentDialog = false
      this.$swal({
        title: "Are you sure?",
        text: `${this.selectedStudent.fullName} left the school.`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          studentService.update(this.selectedStudent.id, { leftDate: this.leftDate, markLeft: true }).then((response) => {
            if (response.data) {
              this.$swal("Left!", "Student was marked Left.", "success");
              // this.$events.emit("customerProfileEvent")
              this.leftStudentClose()
              this.getList();
            }
          });
        }
      });
    },
    leftStudentClose() {
      this.leftStudentDialog = false
      this.leftDate = this.$moment().toISOString()
    },
    viewBalanceLetter(id) {
      const hashId = hashids.encode(id);
      const routeData = this.$router.resolve({
        path: `/global/invoice/${hashId}/PendingBalanceLetter`,
      });
      window.open(routeData.href, "newwindow", "width=850, height=1100");
    },
    viewChangeLetter(id) {
      const hashId = hashids.encode(id);
      const routeData = this.$router.resolve({
        path: `/global/invoice/${hashId}/FeeChangeLetter`,
      });
      window.open(routeData.href, "newwindow", "width=850, height=1100");
    },
    deleteStudent(student) {
      this.$swal({
        title: "Are you sure?",
        text: `You want to remove ${student.fullName}.`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          studentService.delete(student.id).then((response) => {
            if (response.data) {
              this.$swal("Deleted!", "Student has been deleted.", "success");
              this.$events.emit("customerProfileEvent")
              this.getList();
            }
          });
        }
      });
    },
  },
};
</script>
